import Image from "next/image";

export default function BannerAside() {
  return (
    <div className='col-span-5 flex flex-col bg-stone-100 h-screen'>
        <div className='justify-start'>
        <Image
            width={272}
            height={125}
            src="/login/logo.png"
            alt="image"
        />
        </div>
        <div className='text-center mt-4'>
        <Image
            width={529}
            height={673}
            src="/login/banner.png"
            alt="image"
            />
        </div>
    </div>
  )
}
